export default {
      id: "search-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.svg#search",
      toString: function () {
        return this.url;
      }
    }